import { mapGetters } from 'vuex';
import mvtCollapse from '@/common/components/mvtcollapse/mvt-collapse.vue';
import format from '@/common/utilities/format.js';

export default {
    name: 'propertyHistory',
    components: {
        mvtCollapse,
    },
    props: ['disableCollapse', 'isActive'],
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('dpp', ['dpp', 'getPriceHistory']),
        description() {
            var latest = this.getPriceHistory && this.getPriceHistory[0];
            let priceDesktop = latest.status === 'Sold' && this.dpp.hidePropertyPrice ? '—' : latest.priceDesktop;
            let dateDesktop = latest.dateDesktop || '—';
            if (latest && (latest.dateDesktop || latest.priceDesktop)) {
                if (latest.priceChangeTag === 2) {
                    return `Price Changed on ${dateDesktop} to ${priceDesktop}${latest.isRental ? '/Mo' : ''}`;
                }
                return `${latest.status} on ${dateDesktop} for ${priceDesktop}${latest.isRental ? '/Mo' : ''}`;
            }
            return '';
        },
        historyData() {
            let group = [];
            if (this.getPriceHistory && this.getPriceHistory.length) {
                let history = this.getPriceHistory.filter((item) => {
                    if (this.hideSoldHistory()) {
                        return item.status && !/sold/i.test(item.status);
                    }
                    return true;
                });
                history = history.sort((a, b) => {
                    return new Date(b.date) - new Date(a.date);
                });
                let mlsNumbers = history.map((item) => item.mlsNumber);
                mlsNumbers = [...new Set(mlsNumbers)];
                mlsNumbers.forEach((mlsNumber) => {
                    let dateByMls = history.find((item) => item.mlsNumber === mlsNumber).date;
                    let groupItem = {
                        mlsNumber: mlsNumber,
                        //date mm/yyyy
                        dateMonthYear: dateByMls ? format.formateMonthYear(dateByMls) : '',
                        history: [],
                    };
                    history.forEach((item) => {
                        if (item.mlsNumber === mlsNumber) {
                            groupItem.history.push(item);
                        }
                    });
                    group.push(groupItem);
                });
            }
            return group;
        },
    },
    methods: {
        ...mapGetters('glb', ['getComplianceMethod']),
        hideHistory() {
            const compliance = this.getComplianceMethod()();
            return compliance[0] && compliance[0].rule.indexOf('hideHistory') >= 0;
        },
        hideSoldHistory() {
            const compliance = this.getComplianceMethod()();
            return compliance[0] && compliance[0].rule.indexOf('hideSoldHistory') >= 0;
        },
        shouldShowHistoryLogo() {
            const compliance = this.getComplianceMethod()();
            return compliance[0] && compliance[0].rule.indexOf('hideHistoryLogo') === -1;
        },
        getClass(priceChangeTag) {
            var classMapper = {
                1: 'text-green',
                2: 'text-red',
            };
            return classMapper[priceChangeTag] || '';
        },
        mlsLogoSrc(mlsId) {
            if (!this.dpp.showAsPR && mlsId) {
                return this.glb.cdnUrl + 'images/desktop/logo/logo_' + mlsId + '.png';
            }
        },
    },
};
